export default "__VITE_ASSET__YAZtq8Sd__"